export const selectFaq = (state) => state.faqReducer.data;
